import React, { useEffect } from "react";
import eventBus from "../../../eventBus";
const SupportLinksDropdown = () => {
    const handleClick = (routeId) => {
        window.open(`/vertical/manuals/${routeId}`, "_blank");
    };
    const handleMenuClick = ({ key }) => {
        switch (key) {
            case "user-manual":
                handleClick("user");
                break;
            case "admin-manual":
                handleClick("admin");
                break;
            case "contact-support":
                window.location.href = "mailto:support@delphi.care";
                break;
            default:
                break;
        }
    };
    useEffect(() => {
        eventBus.addEventListener("userManualEvent", () => handleMenuClick({ key: "user-manual" }));
        eventBus.addEventListener("adminManualEvent", () => handleMenuClick({ key: "admin-manual" }));
        eventBus.addEventListener("contactSupportEvent", () => handleMenuClick({ key: "contact-support" }));
        return () => {
            eventBus.removeEventListener("userManualEvent", () => handleMenuClick({ key: "user-manual" }));
            eventBus.addEventListener("adminManualEvent", () => handleMenuClick({ key: "admin-manual" }));
            eventBus.addEventListener("contactSupportEvent", () => handleMenuClick({ key: "contact-support" }));
        };
    }, []);
    return (React.createElement(React.Fragment, null));
};
export default SupportLinksDropdown;
